import { PerformanceChart, checkedLegendLabel } from "./performance-chart";
import { PerformanceRates } from "./performance-rates";

const portfoliosConfig = [
  { weight_name: "fortressweight", name: "Fortress Fund¹" },
  { weight_name: "seventythirty", name: "70/30 Portfolio²" },
  { weight_name: "sandpweight", name: "MSCI ACWI Global Equit³" },
  { weight_name: "barclaysweight", name: "US Aggregate Bond⁴" }
];

const RATES_DATA_URL =
  __RATES_DATA_URL__;
const DRAWDOWN_DATA_URL =
  __DRAWDOWN_DATA_URL__;
const FORTRESS_RETURNS_DATA_URL =
  "https://abrahamtrading.s3.amazonaws.com/data/1KIbkNBfuTk01GF39chM6u1jwd6HblqKkulbZzZ8xa9s";

const chartColors = {
  fortress: "#253945",
  msci: "#648442",
  seventy: "#7cb5ec",
  bond: "#5e7571"
};

const currentYear = new Date().getFullYear();

let initialized = false;
let legendsStatus = {};
let chartInstances = [];

export function initPerformanceCharts() {
  const chartSets = createChartSets();

  if (initialized || chartSets.length === 0) return;

  initialized = true;

  if (!window.Highcharts || !window.dateFns) {
    console.error("Performance charts require Highcharts and date-fns.");
    return;
  }

  Highcharts.setOptions({
    lang: {
      thousandsSep: ","
    }
  });

  const ratesManager = new PerformanceRates(
    RATES_DATA_URL,
    DRAWDOWN_DATA_URL,
    FORTRESS_RETURNS_DATA_URL
  );
  const chartOptions = {
    ratesManager: ratesManager,
    portfoliosConfig: portfoliosConfig,
    colors: chartColors
  };
  chartSets.forEach(function(chartSet) {
    initChartSet(chartSet, chartOptions);
  });

  ratesManager
    .fetch()
    .then(function(rates) {
      normalizeRates(rates);
      chartSets.forEach(appendCharts);
      reflowPerformanceCharts();
    })
    .catch(function(err) {
      console.log("Unable to load rates: ", err);
    });
}

export function reflowPerformanceCharts() {
  chartInstances.forEach(function(chart) {
    if (chart && chart.chart) {
      chart.chart.reflow();
    }
  });
}

export function hasPerformanceCharts() {
  return document.querySelectorAll(
    '[data-chart="performance"], [data-chart="fortress-returns"], ' +
      '[data-chart="drawdown"]'
  ).length > 0;
}

function createChartSets() {
  return Array.prototype.slice.call(
    document.querySelectorAll(
      '[data-chart="performance"], [data-chart="fortress-returns"], ' +
        '[data-chart="drawdown"]'
    )
  ).map(function(container) {
    const chartSet = emptyChartSet();

    chartSet[chartKeyForType(container.getAttribute("data-chart"))] = container;

    return chartSet;
  });
}

function emptyChartSet() {
  return {
    performanceChart: null,
    fortressPerformanceChart: null,
    drawdownChart: null
  };
}

function chartKeyForType(type) {
  if (type === "fortress-returns") return "fortressPerformanceChart";
  if (type === "drawdown") return "drawdownChart";
  return "performanceChart";
}

function initChartSet(chartSet, chartOptions) {
  Object.keys(chartSet).forEach(function(key) {
    if (chartSet[key]) {
      const chart = new PerformanceChart(chartSet[key], chartOptions);

      chart.init();
      chartSet[key] = chart;
      chartInstances.push(chart);
    }
  });
}

function appendCharts(chartSet) {
  if (chartSet.performanceChart) {
    chartSet.performanceChart.appendInitialCharts("06/01/2018", null, {
      dateFormat: "MMM YY",
      plotOptions: linePlotOptions()
    });
  }

  if (chartSet.fortressPerformanceChart) {
    chartSet.fortressPerformanceChart.appendFortressReturnsChart(
      "01/01/" + currentYear,
      {
        dateFormat: "MMM YY",
        plotOptions: linePlotOptions(),
        yAxis: {
          opposite: true
        }
      }
    );
  }

  if (chartSet.drawdownChart) {
    chartSet.drawdownChart.appendDrawdownChart("06/01/2018", {
      plotOptions: linePlotOptions()
    });
  }
}

function linePlotOptions() {
  return {
    areaspline: {
      fillOpacity: 0
    },
    series: {
      marker: {
        symbol: "circle",
        radius: 8
      },
      events: legendClickEvent
    }
  };
}

function normalizeRates(rates) {
  rates.forEach(function(rate) {
    Object.keys(rate).forEach(function(key) {
      if (typeof rate[key] !== "string") {
        rate[key] = roundFourDecimal(rate[key]);
      }
    });
  });
}

function roundFourDecimal(num) {
  return +(Math.round(num + "e+4") + "e-4");
}

const legendClickEvent = {
  legendItemClick: function() {
    legendsStatus[this.name] = this.visible;
    this.chart.legend.update({
      useHTML: true,
      labelFormatter: function() {
        return checkedLegendLabel(this.name, this.color, !legendsStatus[this.name]);
      }
    });
    $(this.chart.series).each(function(index, serie) {
      if (serie.legendSymbol) serie.legendSymbol.hide();
      if (serie.legendLine) serie.legendLine.hide();
    });
  }
};
